"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../Icon");
var styles = __importStar(require("./modal.module.css"));
var Modal = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, active = _a.active, onClose = _a.onClose, children = _a.children, _c = _a.closable, closable = _c === void 0 ? true : _c;
    return (react_1.default.createElement("div", { className: "".concat(className, " ").concat(styles.modal_css, " ").concat(active && styles.active) },
        react_1.default.createElement("div", { className: styles.body },
            closable && (react_1.default.createElement("div", { className: styles.close, onClick: onClose },
                react_1.default.createElement(Icon_1.Icon, { icon: "close" }))),
            children)));
};
exports.Modal = Modal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL01vZGFsL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdEQUF5QjtBQUN6QixnQ0FBNEI7QUFDNUIseURBQTRDO0FBRXJDLElBQU0sS0FBSyxHQUFHLFVBQUMsRUFBNEQ7UUFBM0QsaUJBQWMsRUFBZCxTQUFTLG1CQUFHLEVBQUUsS0FBQSxFQUFFLE1BQU0sWUFBQSxFQUFFLE9BQU8sYUFBQSxFQUFFLFFBQVEsY0FBQSxFQUFFLGdCQUFlLEVBQWYsUUFBUSxtQkFBRyxJQUFJLEtBQUE7SUFDN0UsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBRSxVQUFHLFNBQVMsY0FBSSxNQUFNLENBQUMsU0FBUyxjQUFJLE1BQU0sSUFBSSxNQUFNLENBQUMsTUFBTSxDQUFFO1FBQ3pFLHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsSUFBSTtZQUN0QixRQUFRLElBQUksQ0FDVCx1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLEtBQUssRUFBRSxPQUFPLEVBQUUsT0FBTztnQkFDMUMsOEJBQUMsV0FBSSxJQUFDLElBQUksRUFBQyxPQUFPLEdBQUcsQ0FDbkIsQ0FDVDtZQUNBLFFBQVEsQ0FDUCxDQUNKLENBQ1QsQ0FBQTtBQUNMLENBQUMsQ0FBQTtBQWJZLFFBQUEsS0FBSyxTQWFqQiJ9